import axios from 'axios';

export default class FetchHelper {

	request(method, params) {

		let apiHeaders = {
			'Content-Type': (params.isJson)?'application/json':'application/x-www-form-urlencoded;charset=UTF-8'
		};
		if(typeof window.__PRELOADED_STATE__ != 'undefined' && typeof window.__PRELOADED_STATE__.webp != 'undefined' && window.__PRELOADED_STATE__.webp){
           apiHeaders.Accept = 'application/json,text/plain.image/webp,*/*;';
		}
		let options = {
			method: (method)? method: 'get',
			url: params.url,
			headers: apiHeaders,
			withCredentials: (params.includeCredentials) ? params.includeCredentials : false
		};

		if (params.data){
			options.data = params.data;
		}
		
		return this.apiCall(options);
	}

	apiCall(options) {
		return axios(options);
	}
}


// WEBPACK FOOTER //
// ../q-cars/src/utils/FetchHelper.js